import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];
const KEY = "lh_preloaded";

export const shouldPreload = () => {
  try {
    return !sessionStorage.getItem(KEY);
  } catch {
    return false;
  }
};

export const Preloader = ({ onReady, onDone }) => {
  const [count, setCount] = useState(0);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const start = performance.now();
    const duration = 1400;
    let raf;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setCount(Math.round(eased * 100));
      if (p < 1) {
        raf = requestAnimationFrame(tick);
      } else {
        try {
          sessionStorage.setItem(KEY, "1");
        } catch {}
        onReady?.();
        setTimeout(() => setLeaving(true), 180);
      }
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [onReady]);

  return (
    <AnimatePresence onExitComplete={onDone}>
      {!leaving && (
        <motion.div
          data-testid="preloader"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="fixed inset-0 z-[200] flex flex-col justify-between bg-[#050505] px-6 py-8 text-zinc-100 sm:px-10"
          aria-live="polite"
        >
          <div className="flex items-center justify-between">
            <span className="font-display text-lg font-extrabold tracking-tight">
              LUIZ<span className="text-[#E50914]">.DEV</span>
            </span>
            <span className="font-mono-code text-[10px] uppercase tracking-[0.35em] text-zinc-500">
              Portfólio 2026
            </span>
          </div>

          <div className="flex items-end justify-between">
            <div className="overflow-hidden">
              <motion.p
                initial={{ y: "100%" }}
                animate={{ y: 0 }}
                transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
                className="font-mono-code text-xs uppercase tracking-[0.3em] text-zinc-500"
              >
                Carregando experiência
              </motion.p>
            </div>
            <span
              data-testid="preloader-counter"
              className="font-display text-[22vw] font-extrabold leading-none tracking-tighter text-zinc-100 sm:text-[9rem]"
            >
              {count}
              <span className="text-[#E50914]">%</span>
            </span>
          </div>

          <div className="h-px w-full bg-[#1A1A20]">
            <div className="h-full bg-[#E50914] transition-[width] duration-100" style={{ width: `${count}%` }} />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
